// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"qV-z","sponsoredTooltipWrapper":"rV-z","sponsoredTooltip":"sV-z","newCard":"tV-z"};